import React from 'react';
import { Question, Answer } from '../../gds-api-client';
import { Footer, TripleAction, RouterContext } from '../../gs-component-right-rail';

import { Event, Person } from '../interfaces';
import HeaderWithTabs from '../RightRailContent/HeaderWithTabs';
import { EditHouseholdAnswers, EditEventAnswers } from './EditAnswerForm';
import ComponentStateContext from '../ComponentStateContext';

interface EditAnswersP {
  formikValues: any;
  guestWeddingQuestions: Question[] | null;
  events: Event[];
  resetForm: () => void;
  onSubmit: () => void;
  onClose: () => void;
}

const editResponseText = (where: string): string => `Edit '${where}' Responses`;

interface HEP {
  questions: Question[] | null;
  answers: Answer[];
  goBack: () => void;
  onClose: () => void;
}

interface EEP {
  people: Person[];
  event: Event | null;
  goBack: () => void;
  onClose: () => void;
}

const HouseholdEdit: React.FC<HEP> = ({ goBack, questions, answers, onClose }) => {
  if (!questions || !questions.length) return null;
  return (
    <>
      <HeaderWithTabs goBack={goBack} showConfirmation={false} showTabs={false} onClose={onClose}>
        {editResponseText('General Questions')}
      </HeaderWithTabs>
      <EditHouseholdAnswers questions={questions} answers={answers} />
    </>
  );
};

const EventEdit: React.FC<EEP> = ({ goBack, people, event, onClose }) => {
  if (!event || !event.questions) return null;
  return (
    <>
      <HeaderWithTabs goBack={goBack} showConfirmation={false} showTabs={false} onClose={onClose}>
        {editResponseText(event.name)}
      </HeaderWithTabs>
      <EditEventAnswers people={people} questions={event.questions} eventId={event.id} />
    </>
  );
};

const EditAnswers: React.FC<EditAnswersP> = ({
  formikValues,
  guestWeddingQuestions,
  events,
  resetForm,
  onSubmit,
  onClose,
}) => {
  const { editForm } = React.useContext(ComponentStateContext);
  const { push } = React.useContext(RouterContext);

  const goBack = (): void => {
    resetForm();
    push('responses');
  };

  const handleSubmit = (): void => {
    onSubmit();
    push('responses');
  };

  const renderComponent = (): React.ReactNode | null => {
    if (!editForm) return null;
    switch (editForm.type) {
      case 'GENERAL':
        return (
          <HouseholdEdit
            goBack={goBack}
            onClose={onClose}
            questions={guestWeddingQuestions}
            answers={formikValues.answers}
          />
        );
      case 'EVENT':
        // eslint-disable-next-line no-case-declarations
        const event = events.find(e => e.id === editForm.id);
        return <EventEdit goBack={goBack} onClose={onClose} people={formikValues.people} event={event || null} />;
      default:
        return null;
    }
  };

  return (
    <>
      {renderComponent()}
      <Footer>
        <TripleAction
          primaryText="Save"
          secondaryText="Cancel"
          primaryOnClick={handleSubmit}
          secondaryOnClick={goBack}
        />
      </Footer>
    </>
  );
};

export default EditAnswers;
